function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M26.8 12.5a2.15 2.15 0 0 1 2.31 2.25A3 3 0 0 1 26 17.64a2.06 2.06 0 0 1-2.27-2.29 3 3 0 0 1 3.07-2.85zm-4.74 23c-1.22 0-2.11-.75-1.26-4.05l1.4-5.86c.24-.94.28-1.31 0-1.31a9.19 9.19 0 0 0-2.88 1.29l-.61-1c3-2.51 6.36-4 7.82-4 1.22 0 1.42 1.46.81 3.71l-1.6 6.15c-.28 1.09-.16 1.46.12 1.46a6.26 6.26 0 0 0 2.74-1.39l.69.94c-2.88 2.93-6.02 4.06-7.24 4.06z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M24 4A20 20 0 1 1 4 24 20 20 0 0 1 24 4m0-4a24 24 0 1 0 24 24A24 24 0 0 0 24 0z"
});

var SvgInformationOutline = function SvgInformationOutline(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 48 48"
  }, props), _ref, _ref2);
};

export default SvgInformationOutline;